<template>
    <div v-if="loaded">
        <form class="signup_form" @submit.prevent="$emit('next', parseData)">
          <ul>
              <div class="part">
                  <li>
                      <label>טלפון המשרד</label>
                      <input type="text" v-model="formData.company_office_phone" >
                  </li>
                  <li>
                      <label>תחומי מומחיות</label>
                      <wzMultiSelect v-model="formData.expertise" :settings="{ width: '100%', val: 'name', key: 'id', theme: 'light'}" :options="$store.expertise" v-if="$store.expertise.length > 0"/>
                      <!-- <select v-model="formData.expertise">
                        <option value="">בחירה מתוך הרשימה</option>
                        <option v-for="item in list" :key="item.id" :value="item.id" >{{ item.name }}</option>
                      </select> -->
                  </li>
                  <li>
                      <label>כתובת המשרד</label>
                      <input type="text" v-model="formData.company_address" >
                  </li>
                  <li>
                      <label>קישור לאתר האינטרנט של המשרד</label>
                      <input type="text" v-model="formData.link_company_site">
                  </li>
              </div>
              <input v-if="state != 'edit'" type="submit" class="btn" value="המשך">
          </ul>
        </form>
    </div>
</template>

<script>
import WzMultiSelect from '../wzMultiSelect.vue';


export default {
    components: {WzMultiSelect},
    props: ["updatedData", "state"],
    data() {
        return {
            loaded:false,
            selectedList: [],
            formData: {
                company_office_phone: '',
                expertise: '',
                company_address: '',
                link_company_site: '',
                step: 2
            }
        }
    },
    mounted() {
        if (this.updatedData) {
            for (const key in this.formData) {
                if (this.updatedData[key]) this.formData[key] = this.updatedData[key];
            }
            this.loaded = true
        }
    },
    computed: {
        parseData() {
            return this.formData;
        }
    },
    watch: {
        selectedList() {
            console.log("dd", this.selectedList);
        },
        formData: {
            handler: function (val) {
                this.$emit('update', val)
            },
            deep: true
        }
    }
}
</script>

<style>

</style>